export default __webpack_public_path__ + "static/visually-appealing-desktop-2-65bdf79267cd82c12a297d826341018d.webp";